$(document).ready(function () {
  if ($('.frame').data('page') == 'consulting') {
    // consultingBanner
    const consultingBanner = gsap.timeline();
    consultingBanner
      .from(".banner-consulting-img", { delay: 0.3, duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })


    let mm = gsap.matchMedia();
    mm.add("(max-width: 640px)", () => {
      // consultingProcess
      let consultingProcess_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#consultingProcess",
          start: "top 40%",
        }
      });
      consultingProcess_tl
        .from("#consultingProcess .process-item:nth-child(1)", { duration: 0.5, y: -30, opacity: 0, ease: 'circ.out' })
        .from("#consultingProcess .process-item:nth-child(2)", { duration: 0.5, y: -30, opacity: 0, ease: 'circ.out' })
        .from("#consultingProcess .process-item:nth-child(3)", { duration: 0.5, y: -30, opacity: 0, ease: 'circ.out' })
        .from("#consultingProcess .process-item:nth-child(4)", { duration: 0.5, y: -30, opacity: 0, ease: 'circ.out' })
    });

    mm.add("(min-width: 641px)", () => {
      // consultingProcess
      let consultingProcess_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#consultingProcess",
          start: "top 40%",
        }
      });
      consultingProcess_tl
        .from("#consultingProcess .process-item:nth-child(1)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
        .from("#consultingProcess .process-item:nth-child(2)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
        .from("#consultingProcess .process-item:nth-child(3)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
        .from("#consultingProcess .process-item:nth-child(4)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
    });


    // consultingReasons
    let consultingReasons_tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#consultingReasons",
        start: "top 40%",
      }
    });
    consultingReasons_tl
      .from(".reason-card:nth-child(1)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
      .from(".reason-card:nth-child(2)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
      .from(".reason-card:nth-child(3)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
      .from(".reason-card:nth-child(4)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")


    // consultingServices
    let consultingServices_tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#consultingServices",
        start: "top 40%",
      }
    });
    consultingServices_tl
      .from(".inner-left .services-item:nth-child(1)", { duration: 0.5, scale: 0, ease: 'circ.out' })
      .from(".inner-left .services-item:nth-child(2)", { duration: 0.5, scale: 0, ease: 'circ.out' }, "-=0.2")
      .from(".inner-left .services-item:nth-child(3)", { duration: 0.5, scale: 0, ease: 'circ.out' }, "-=0.2")
      .from(".inner-right .services-item:nth-child(1)", { duration: 0.5, scale: 0, ease: 'circ.out' }, "-=0.2")
      .from(".inner-right .services-item:nth-child(2)", { duration: 0.5, scale: 0, ease: 'circ.out' }, "-=0.2")


    // consultingTarget
    let consultingTarget_tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#consultingTarget",
        start: "top 40%",
      }
    });
    consultingTarget_tl
      .from(".consulting-target-item:nth-child(1)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
      .from(".consulting-target-item:nth-child(2)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
      .from(".consulting-target-item:nth-child(3)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
      .from(".consulting-target-item:nth-child(4)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
      .from(".consulting-target-item:nth-child(5)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")


    // consulting-contact
    let consultingContact_tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#consulting-contact .image-wrap",
        start: "top 60%",
      }
    });
    gsap.set(".search-img", { transformOrigin: "right bottom" });
    consultingContact_tl
      .from(".search-img", { delay: 0.3, duration: 0.5, x: 80, y: 80, opacity: 0, ease: 'circ.out' })
      .to(".search-img", { delay: 0.3, duration: 1.5, rotate: -15, repeatDelay: 0.5, repeat: -1, yoyo: true, ease: "sine.inOut" })



    // 錨點連結
    $('a[href*=\\#]:not([href=\\#])').on('click', function() {
      let target = $(this.hash);
      $('html, body').animate({
          scrollTop: target.offset().top - 50
      }, 1000);
      return false;
    });

  }
});